import type { Dispatch, SetStateAction } from 'react'

import { COLOR } from 'vars/index'

export const TimeLineBackground = {
  Default: COLOR.BACKGROUND_GRAY,
} as const
export type TimeLineBackground =
  (typeof TimeLineBackground)[keyof typeof TimeLineBackground]

export interface ITimeLine {
  now: number
  backgroundColor?: TimeLineBackground
  startTime: number
  scaleDivision: number
  onUpdateTime?: ({
    scaleDivisionMs,
    durationMs,
  }: {
    scaleDivisionMs?: number
    durationMs?: number
  }) => void
  onUpdateStartTime?: ({ startTime }: { startTime?: number }) => void
  setTimeBlockWidth?: Dispatch<SetStateAction<number | undefined>>
  updateStep?: Dispatch<SetStateAction<number | undefined>>
  setSections?: Dispatch<SetStateAction<number>>
  updateShowProgressLine?: Dispatch<SetStateAction<boolean>>
  coveredDays: Array<{
    stamp: number
    formattedString: string
  }>
  formatTime: (arg: Date | number | string) => string
}
